import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const handleCheck = listeners["handleCheck"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const curItem = vo.row;
    let dealConf = [];
    dealConf.push(["iconfont ic_checkinmanagement iconfont-adapt", "编辑座位号", () => handleCheck(curItem), "userSeat:update"])
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const SeatNumber = ({ props: { vo } }) => {
    const seatNumber = vo.row.seatNumber
      ? vo.row.seatNumber
      : "--";
    return <span>{seatNumber}</span>;
  };

  const AccountTableConfig = [
    {
      label: "班组名称",
      prop: "groupName",
      width: "120"
    },
    {
      label: "姓名",
      prop: "userName",
      width: "120"
    },
    {
      label: "工作单位",
      prop: "deptName",
      width: "120",
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      width: "150",
    },
    {
      label: "座位号",
      prop: "seatNumber",
      width: "100",
      render: vo => <SeatNumber vo={vo} />
    },
    {
      label: "操作",
      width: "100",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <div>
      <List
        {...args}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
